import firebase from "../../Firebase"

export const db = firebase.firestore();